import axios from "axios";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

// components

export default function CardCreateUser() {
  const [datas, setDatas] = useState("");
  const [exist, setExist] = useState("");
  const [checkPass, setCheckPass] = useState(false);
  const { user } = useSelector(state => state.user)
  useEffect(() => {
    axios.post(`http://${process.env.REACT_APP_API_URL}/users/search`, { username: datas.username }, {
      headers: {
        Bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      if (response.status === 200) {
        setExist(response.data);
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error);
    });

  }, [datas.username])
  useEffect(() => {
    if (datas.password !== datas.confirm_password) {
      setCheckPass(true);
    } else {
      setCheckPass(false);
    }

  }, [datas])

  const handleData = (e) => {
    setDatas({ ...datas, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    axios.post(`http://${process.env.REACT_APP_API_URL}/users/save`, datas, {
      headers: {
        Bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      console.log(response);
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          text: 'Create User Success!',
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          window.location.href = "/admin/user";
        }
        )
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      // Swal.fire("SweetAlert2 is working!");

      // console.log(error);
      console.log(error.response.data.message);
    });
  };
  return (
    <>
      <div className="relative flex flex-col w-full min-w-0 p-5 mb-6 break-words bg-white rounded shadow-lg" style={{borderRadius:"20px"}}>
        <div className="px-4 py-3 mb-0 border-0 rounded">
          <div className="flex flex-wrap items-center">
            <div className="relative flex-1 flex-grow w-full max-w-full mb-2">
              <h1 className="text-3xl font-bold semibold text-blueGray-700">
                Create User
              </h1>
            </div>
          </div>
        </div>
        <div className="block w-full mb-1 overflow-x-auto ">
          {/* Projects table */}
          <form onSubmit={(e) => { handleSubmit(e) }}>
            <div className="grid mb-6 -mx-3">
              <div className="flex">
                <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    Firstname
                  </label>
                  <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    id="nameTh" name="nameTh" type="text" onChange={handleData} />
                  {/* <p className="text-xs italic text-red-500">Please fill out this field.</p> */}
                </div>
                <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    Lastname
                  </label>
                  <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    id="lastnameTh" name="lastnameTh" type="text" onChange={handleData} />
                  {/* <p className="text-xs italic text-red-500">Please fill out this field.</p> */}
                </div>
              </div>
              <div className="flex">
                <div className="px-3 mb-3 md:mb-0 " style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    Username
                  </label>
                  <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    id="username" name="username" type="text" onChange={handleData} />
                  {(exist && datas.username) && <p className="text-xs italic text-red-500">Username exists</p>}
                </div>

              </div>
              <div className="flex">
                <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    Password
                  </label>
                  <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    id="password" name="password" type="password" onChange={handleData} />
                  {/* <p className="text-xs italic text-red-500">Please fill out this field.</p> */}
                </div>

                <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    Confirm Password
                  </label>
                  <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    id="confirm_password" name="confirm_password" type="password" onChange={handleData} />
                  {checkPass && <p className="text-xs italic text-red-500">Password does not match</p>}
                </div>
              </div>
              <div className="flex">
                <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    Tel
                  </label>
                  <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    id="tel" name="tel" type="text" onChange={handleData} />
                  {/* <p className="text-xs italic text-red-500">Please fill out this field.</p> */}
                </div>

                <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    Team
                  </label>
                  <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    id="team" name="team" type="text" onChange={handleData} value={datas.tel} />
                </div>

                <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    Role
                  </label>
                  <select name="role" id="role" className="rounded" onChange={handleData} style={{  height: "50px" }} >
                    <option value="" disabled selected>Choose Role</option>
                    {user.role == 99 && <option value="99">Super Admin</option>}
                    <option value="1">Admin</option>
                    <option value="2">Sale</option>

                  </select>
                </div>
              </div>
              {/* {!checkPass && !exist && */}
                <div className="w-full px-3 mb-3 md:mb-0">
                  <button
                    className={"px-3 py-3 m-1 mr-1 text-xs font-bold text-white uppercase transition-all duration-150 ease-linear bg-indigo-500 rounded outline-none active:bg-indigo-600 focus:outline-none"}
                    type="submit"
                    disabled={checkPass || exist}
                  >
                    Create User
                  </button>
                </div>
              {/* } */}
            </div>
          </form>

        </div>
      </div>
    </>
  );
}
